import classNames from 'classnames/bind';
import { TaskMode } from 'common/types';
import MyIcon from '@/components/MyIcon';

import styles from './index.module.css';

const cx = classNames.bind(styles);

interface Props {
  mode: TaskMode;
  modelInspectShow: boolean;
  setModelInspectShow: (show: boolean) => void;
  modelThumbMode: boolean;
  setModelThumbMode: (enable: boolean) => void;
  takeSnapShot: () => void;
}
const ModelViewerControl = (props: Props) => {
  const { mode, modelInspectShow, setModelInspectShow, modelThumbMode, setModelThumbMode, takeSnapShot } = props;

  return mode === TaskMode.Edit ? (
    <div className={cx(styles.modelViewerBottom, styles.buttons)}>
      {!modelThumbMode && (
        <div
          className={cx(styles.inspectorButton, styles.button, {
            active: modelInspectShow,
          })}>
          <MyIcon size="24px" icon="模型检查工具" onClick={() => setModelInspectShow(!modelInspectShow)} />
        </div>
      )}
      <MyIcon className={styles.button} size="24px" icon="拍照" onClick={takeSnapShot} />
      {modelThumbMode ? (
        <MyIcon
          className={styles.button}
          size="24px"
          icon="最大化窗口"
          onClick={() => setModelThumbMode(!modelThumbMode)}
        />
      ) : (
        <MyIcon
          className={styles.button}
          size="24px"
          icon="最小化窗口"
          onClick={() => setModelThumbMode(!modelThumbMode)}
        />
      )}
    </div>
  ) : null;
};
export default ModelViewerControl;
